module.exports = __webpack_public_path__ + "img/rich_dad_poor_dad.c68c4fd6.jpg";